//=include _pages/*
class BreadcrumbOverflow {
  constructor(el) {
    this.roots = document.querySelectorAll('.' + el);
    if (!this.roots.length) return;

    this.spQuery = window.matchMedia('(max-width: 767px)');
    this.resizeQueued = false;

    this.items = Array.from(this.roots).map((root) => ({
      root,
      scroller: root.querySelector('.c-breadcrumb__scroller') || root,
    }));

    this.items.forEach((item) => {
      item.scroller.addEventListener(
        'scroll',
        () => this.update(item),
        { passive: true }
      );
    });

    this.spQuery.addEventListener('change', () => this.updateAll());
    window.addEventListener('resize', () => {
      if (this.resizeQueued) return;
      this.resizeQueued = true;
      window.requestAnimationFrame(() => {
        this.resizeQueued = false;
        this.updateAll();
      });
    });

    if (typeof ResizeObserver !== 'undefined') {
      this.observer = new ResizeObserver(() => this.updateAll());
      this.items.forEach((item) => {
        this.observer.observe(item.root);
        this.observer.observe(item.scroller);
      });
    }

    this.updateAll();
  }

  updateAll() {
    this.items.forEach((item) => this.update(item));
  }

  update(item) {
    const { root, scroller } = item;
    const canScroll =
      this.spQuery.matches &&
      scroller.scrollWidth > scroller.clientWidth + 1;

    if (!canScroll) {
      root.classList.remove(
        'is-overflow',
        'is-overflow-start',
        'is-overflow-end'
      );
      return;
    }

    const start = scroller.scrollLeft;
    const max = scroller.scrollWidth - scroller.clientWidth;
    root.classList.add('is-overflow');
    root.classList.toggle('is-overflow-start', start > 1);
    root.classList.toggle('is-overflow-end', start < max - 1);
  }
}

class CareerSlider {
  constructor(el) {
    this.root = document.querySelector('.' + el);
    if (!this.root || typeof Swiper === 'undefined') return;

    this.slides = this.root.querySelectorAll('.swiper-slide');
    if (this.slides.length < 2) return;

    this.pagination = document.querySelector('.js-career-pagination');
    this.reduceMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;
    this.spQuery = window.matchMedia('(max-width: 767px)');
    this.swiper = null;
    this.scrollHint = null;
    this.onDismissHint = () => this.dismissScrollHint();

    this.spQuery.addEventListener('change', () => this.update());
    this.update();
  }

  update() {
    if (this.spQuery.matches) {
      this.init();
    } else {
      this.destroy();
    }
  }

  init() {
    if (this.swiper) return;

    this.swiper = new Swiper(this.root, {
      slidesPerView: 1,
      spaceBetween: '7%',
      speed: this.reduceMotion ? 0 : 600,
      // STEP番号を CSS カウンタで出しているので loop（スライド複製）は使わない
      threshold: 8,
      preventClicks: true,
      preventClicksPropagation: true,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      pagination: {
        el: this.pagination,
        clickable: true,
        bulletClass: 'p-training__career-pagination-bullet',
        bulletActiveClass: 'is-active',
      },
      a11y: {
        enabled: true,
        slideRole: null,
        paginationBulletMessage: '{{index}}番目のステップへ',
      },
    });

    this.initScrollHint();
  }

  initScrollHint() {
    if (this.scrollHint || typeof ScrollHint === 'undefined') return;

    // Swiper は transform で動くため scrollWidth 判定が偽陰性になる。
    // offset を負にしてヒント表示条件だけ通し、overflow は直後に戻す。
    this.scrollHint = new ScrollHint(this.root, {
      enableOverflowScrolling: false,
      offset: -1,
      i18n: {
        scrollable: 'スクロールできます',
      },
    });

    this.root.style.overflow = 'hidden';

    this.swiper.on('touchStart', this.onDismissHint);
    this.swiper.on('slideChange', this.onDismissHint);
    if (this.pagination) {
      this.pagination.addEventListener('click', this.onDismissHint);
    }
  }

  dismissScrollHint() {
    if (!this.scrollHint || !this.scrollHint.items) return;

    this.scrollHint.items.forEach((item) => {
      item.interacted = true;
      this.scrollHint.updateItem(item);
    });
  }

  destroyScrollHint() {
    if (!this.scrollHint) return;

    if (this.swiper) {
      this.swiper.off('touchStart', this.onDismissHint);
      this.swiper.off('slideChange', this.onDismissHint);
    }
    if (this.pagination) {
      this.pagination.removeEventListener('click', this.onDismissHint);
    }

    const icon = this.root.querySelector('[data-target="scrollable-icon"]');
    if (icon) icon.remove();

    this.root.classList.remove(
      'scroll-hint',
      'is-scrollable',
      'is-right-scrollable',
      'is-left-scrollable'
    );
    this.root.style.position = '';
    this.root.style.overflow = '';
    this.scrollHint = null;
  }

  destroy() {
    this.destroyScrollHint();

    if (!this.swiper) return;
    this.swiper.destroy(true, true);
    this.swiper = null;
  }
}

// 参考サイト
// https://hacknote.jp/archives/15289/

let cookie = {
	/**
	 * 取得
	 * @param {string} cookieName 取得するCookieの名前
	 */
	get : function(cookieName) {
		if (!navigator.cookieEnabled) return false;

		var getCookieAllData  = document.cookie,
		    getCookieAllDatas = getCookieAllData.split(';'),
		    getCookieDatas    = {},
		    cookieKeyValue    = [],
		    cookieKey         = '',
		    cookieValue       = '';

		var hashLength = function(arr) {
			var result = 0, key = false;

			if (typeof arr !== 'object') return false;

			for (key in arr) result++;

			return result;
		};

		for (var i = 0, len = getCookieAllDatas.length; i < len; i++) {
			if (getCookieAllDatas[i] && getCookieAllDatas[i] !== '') {
				cookieKeyValue = getCookieAllDatas[i].split('=');
				cookieKey      = cookieKeyValue[0].replace(/^\s+/, '');
				cookieValue    = '';

				if (cookieKeyValue[1]) {
					cookieValue = decodeURIComponent(cookieKeyValue[1]);
				}

				getCookieDatas[cookieKey] = cookieValue;
			}
		}

		if (hashLength(getCookieDatas) > 0) {
			if (cookieName && cookieName in getCookieDatas) {
				return getCookieDatas[cookieName];
			} else {
				return getCookieDatas;
			}
		} else {
			return '';
		}
	},

	/**
	 * 設定
	 * @param {string} cookieName 設定するCookieの名前
	 * @param {string} value 設定する値
	 * @param {string} domain 有効ドメイン
	 * @param {string} path 有効パス
	 * @param {string} expires 有効期限
	 * @param {boolean} secure セキュアとするか
	 * @return {boolean} 設定に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	set : function(cookieName, value, domain, path, expires, secure) {
		if (!navigator.cookieEnabled || !cookieName || !value) return false;

		var date, dt, ts, ts_after;

		var setCookieData = cookieName + '=' + encodeURIComponent(value) + ';';

		if (domain) setCookieData += 'domain=' + domain + ';';

		if (path) setCookieData += 'path=' + path + ';';

		if (expires) {
      dt = new Date();
      ts = dt.getTime();

      // 1時間後
      ts_after = ts + (1000 * 60 * 60 * expires);

      date = new Date(ts_after);
			setCookieData += 'expires=' + date.toGMTString() + ';';
		}

		if (secure && secure === true && location.protocol.match(/https/)) {
			setCookieData += 'secure';
		}

		document.cookie = setCookieData;

		return true;
	},

	/**
	 * 削除
	 * @param {string} cookieName 削除するCookieの名前
	 * @return {boolean} 削除に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	del : function(cookieName) {
		if (!navigator.cookieEnabled || !cookieName) return false;

		var getCookieDatas = this.get();

		if (getCookieDatas[cookieName]) {
			var setCookieData = cookieName + '=;',
			    date          = new Date(0);

			setCookieData += 'expires=' + date.toGMTString() + '';

			document.cookie = setCookieData;

			return true;
		}

		return false;
	}
};
class DataCharts {
  constructor(el) {
    this.root = document.querySelector('.' + el);
    if (!this.root) return;

    this.reduceMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;
    this.duration = 1400;
    this.nums = Array.from(this.root.querySelectorAll('.p-data__num'));
    this.donuts = Array.from(
      this.root.querySelectorAll('.p-data__donut[data-chart]')
    );

    this.prepareNumbers();
    this.observe();
  }

  prepareNumbers() {
    this.nums.forEach((num) => {
      const raw = num.textContent.trim();
      const grouped = raw.includes(',');
      const normalized = raw.replace(/,/g, '');
      const decimals = (normalized.split('.')[1] || '').length;
      const target = Number(normalized);

      if (!Number.isFinite(target)) return;

      num.dataset.countTarget = String(target);
      num.dataset.countDecimals = String(decimals);
      num.dataset.countGrouped = grouped ? '1' : '0';

      if (!this.reduceMotion) {
        this.writeNumber(num, this.formatNumber(0, decimals, grouped));
      }
    });
  }

  observe() {
    if (this.reduceMotion) {
      this.donuts.forEach((donut) => this.drawChart(donut));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio < 0.35) return;

          observer.unobserve(entry.target);
          this.play(entry.target);
        });
      },
      { threshold: [0, 0.35, 1] }
    );

    this.donuts.forEach((donut) => observer.observe(donut));
    this.nums.forEach((num) => {
      if (num.closest('.p-data__donut')) return;
      observer.observe(num);
    });
  }

  play(target) {
    if (target.classList.contains('p-data__donut')) {
      target.querySelectorAll('.p-data__num').forEach((num) => this.countUp(num));
      this.drawChart(target);
      return;
    }

    this.countUp(target);
  }

  countUp(num) {
    if (num.dataset.countPlayed === '1') return;
    if (!num.dataset.countTarget) return;

    num.dataset.countPlayed = '1';

    const target = Number(num.dataset.countTarget);
    const decimals = Number(num.dataset.countDecimals) || 0;
    const grouped = num.dataset.countGrouped === '1';
    const start = performance.now();

    const tick = (now) => {
      const progress = Math.min((now - start) / this.duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      this.writeNumber(num, this.formatNumber(target * eased, decimals, grouped));

      if (progress < 1) {
        requestAnimationFrame(tick);
      }
    };

    requestAnimationFrame(tick);
  }

  kernNumber(formatted) {
    return String(formatted).replace(/1|7|,/g, (char) => {
      if (char === '1') {
        return '<span class="p-data__digit p-data__digit--1">1</span>';
      }

      if (char === '7') {
        return '<span class="p-data__digit p-data__digit--7">7</span>';
      }

      return '<span class="p-data__digit p-data__digit--comma">,</span>';
    });
  }

  writeNumber(num, formatted) {
    const intEl = num.querySelector('.p-data__num-int');
    const decEl = num.querySelector('.p-data__num-dec');

    if (!intEl) {
      num.innerHTML = this.kernNumber(formatted);
      return;
    }

    const dot = formatted.indexOf('.');
    if (dot === -1) {
      intEl.innerHTML = this.kernNumber(formatted);
      if (decEl) decEl.textContent = '';
      return;
    }

    intEl.innerHTML = this.kernNumber(formatted.slice(0, dot + 1));
    if (decEl) decEl.innerHTML = this.kernNumber(formatted.slice(dot + 1));
  }

  formatNumber(value, decimals, grouped) {
    const fixed = value.toFixed(decimals);
    if (!grouped) return fixed;

    const parts = fixed.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }

  drawChart(donut) {
    if (donut.dataset.chartPlayed === '1') return;
    if (typeof Chart === 'undefined') return;

    const canvas = donut.querySelector('.p-data__donut-canvas');
    if (!canvas) return;

    const segments = donut.dataset.chart.split(',').map((part) => {
      const [value, color] = part.split(':');
      return {
        value: Number(value),
        color: color,
      };
    }).filter((item) => Number.isFinite(item.value) && item.color);

    if (!segments.length) return;

    const wrap = canvas.parentElement;
    if (!wrap || !wrap.clientWidth || !wrap.clientHeight) {
      requestAnimationFrame(() => this.drawChart(donut));
      return;
    }

    donut.dataset.chartPlayed = '1';
    donut.classList.add('is-charted');

    const values = segments.map((item) => item.value);
    const duration = this.reduceMotion ? 0 : this.duration;
    const cutout = donut.dataset.cutout ? `${donut.dataset.cutout}%` : '72%';
    const chart = new Chart(canvas, {
      type: 'doughnut',
      data: {
        datasets: [
          {
            data: values.map(() => 0),
            backgroundColor: segments.map((item) => item.color),
            borderWidth: 0,
            hoverBorderWidth: 0,
            spacing: 0,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        cutout: cutout,
        radius: '100%',
        animation: {
          animateRotate: true,
          animateScale: false,
          duration: 0,
          easing: 'easeOutCubic',
        },
        transitions: {
          resize: {
            animation: {
              duration: 0,
            },
          },
        },
        plugins: {
          legend: { display: false },
          tooltip: { enabled: false },
        },
        events: [],
      },
    });

    // 初期化直後の resize が回転アニメーションを打ち切るため、
    // レイアウト確定後に 0 から実データへ更新して描く。
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        chart.data.datasets[0].data = values;
        chart.config.options.animation.duration = duration;
        chart.config.options.animation.animateRotate = true;
        chart.update();
      });
    });
  }
}

class FormConvert {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    //全角から半角
    function replaceZtoH(str){
      str = str.replace(/[！-～]/g, function(s){
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
      });
      str = str.replace(/[-－﹣−‐⁃‑‒–—﹘―⎯⏤ーｰ─━]/g, '-');
      return str;
    }
    const el = document.querySelector('.js-convert');
    el.addEventListener('blur', () => {
      const br = el.value;
      const ar = replaceZtoH(br);
      el.value = ar;
    });
  }
}

class FormDropzone {
  constructor(el) {
    this.el = el;
    if (document.querySelectorAll("." + this.el).length > 0) {
      this.event();
    }
  }

  event() {
    const zones = document.querySelectorAll("." + this.el);

    zones.forEach((zone) => {
      const input = zone.querySelector('input[type="file"]');
      const text = zone.querySelector(".c-form__dropzone-text");
      if (!input || !text) {
        return;
      }

      const defaultHtml = text.innerHTML;

      const updateLabel = () => {
        if (input.files && input.files.length > 0) {
          zone.classList.add("has-file");
          text.textContent = input.files[0].name;
        } else {
          zone.classList.remove("has-file");
          text.innerHTML = defaultHtml;
        }
      };

      input.addEventListener("change", updateLabel);

      ["dragenter", "dragover"].forEach((type) => {
        zone.addEventListener(type, (e) => {
          e.preventDefault();
          zone.classList.add("is-dragover");
        });
      });

      ["dragleave", "drop"].forEach((type) => {
        zone.addEventListener(type, (e) => {
          e.preventDefault();
          zone.classList.remove("is-dragover");
        });
      });

      zone.addEventListener("drop", (e) => {
        const files = e.dataTransfer && e.dataTransfer.files;
        if (!files || !files.length) {
          return;
        }
        // CF7 の input に FileList を直接代入できない環境があるため、
        // DataTransfer 経由でセットを試みる
        try {
          const dt = new DataTransfer();
          dt.items.add(files[0]);
          input.files = dt.files;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        } catch (err) {
          // 非対応ブラウザはクリック選択に委ねる
        }
      });
    });
  }
}

class FormPrivacyScroll {
  constructor(el) {
    this.el = el;
    if (document.querySelectorAll("." + this.el).length > 0) {
      this.event();
    }
  }

  event() {
    const boxes = document.querySelectorAll("." + this.el);

    boxes.forEach((box) => {
      this.setup(box);
    });
  }

  setup(box) {
    if (box.dataset.privacyScrollReady === "1") {
      return;
    }
    box.dataset.privacyScrollReady = "1";

    const viewport = this.ensureViewport(box);
    const { bar, track, thumb } = this.ensureScrollbar(box);

    const state = {
      dragging: false,
      startY: 0,
      startScrollTop: 0,
    };

    const update = () => {
      const scrollHeight = viewport.scrollHeight;
      const clientHeight = viewport.clientHeight;
      const maxScroll = scrollHeight - clientHeight;
      const trackHeight = track.clientHeight;

      if (maxScroll <= 0 || trackHeight <= 0) {
        bar.hidden = true;
        return;
      }

      bar.hidden = false;

      const thumbHeight = Math.max(
        (clientHeight / scrollHeight) * trackHeight,
        24
      );
      const maxThumbTop = trackHeight - thumbHeight;
      const thumbTop =
        maxScroll > 0
          ? (viewport.scrollTop / maxScroll) * maxThumbTop
          : 0;

      thumb.style.height = `${thumbHeight}px`;
      thumb.style.transform = `translateY(${thumbTop}px)`;
    };

    viewport.addEventListener("scroll", update, { passive: true });

    thumb.addEventListener("pointerdown", (e) => {
      e.preventDefault();
      state.dragging = true;
      state.startY = e.clientY;
      state.startScrollTop = viewport.scrollTop;
      thumb.setPointerCapture(e.pointerId);
      document.body.style.userSelect = "none";
    });

    thumb.addEventListener("pointermove", (e) => {
      if (!state.dragging) {
        return;
      }

      const scrollHeight = viewport.scrollHeight;
      const clientHeight = viewport.clientHeight;
      const maxScroll = scrollHeight - clientHeight;
      const trackHeight = track.clientHeight;
      const thumbHeight = thumb.offsetHeight;
      const maxThumbTop = trackHeight - thumbHeight;

      if (maxScroll <= 0 || maxThumbTop <= 0) {
        return;
      }

      const deltaY = e.clientY - state.startY;
      const scrollDelta = (deltaY / maxThumbTop) * maxScroll;
      viewport.scrollTop = state.startScrollTop + scrollDelta;
    });

    const endDrag = (e) => {
      if (!state.dragging) {
        return;
      }
      state.dragging = false;
      if (thumb.hasPointerCapture(e.pointerId)) {
        thumb.releasePointerCapture(e.pointerId);
      }
      document.body.style.userSelect = "";
    };

    thumb.addEventListener("pointerup", endDrag);
    thumb.addEventListener("pointercancel", endDrag);

    track.addEventListener("pointerdown", (e) => {
      if (e.target === thumb) {
        return;
      }

      const scrollHeight = viewport.scrollHeight;
      const clientHeight = viewport.clientHeight;
      const maxScroll = scrollHeight - clientHeight;
      const trackHeight = track.clientHeight;
      const thumbHeight = thumb.offsetHeight;
      const maxThumbTop = Math.max(trackHeight - thumbHeight, 1);
      const rect = track.getBoundingClientRect();
      const clickY = e.clientY - rect.top - thumbHeight / 2;
      const ratio = Math.min(Math.max(clickY / maxThumbTop, 0), 1);

      viewport.scrollTop = ratio * maxScroll;
      update();
    });

    if (typeof ResizeObserver !== "undefined") {
      const ro = new ResizeObserver(update);
      ro.observe(viewport);
      ro.observe(box);
    }

    window.addEventListener("resize", update);
    update();
    requestAnimationFrame(update);
  }

  ensureViewport(box) {
    let viewport = box.querySelector(".c-form-privacy__viewport");
    if (viewport) {
      return viewport;
    }

    viewport = document.createElement("div");
    viewport.className = "c-form-privacy__viewport";

    while (box.firstChild) {
      viewport.appendChild(box.firstChild);
    }

    box.appendChild(viewport);
    return viewport;
  }

  ensureScrollbar(box) {
    let bar = box.querySelector(".c-form-privacy__scrollbar");

    if (!bar) {
      bar = document.createElement("div");
      bar.className = "c-form-privacy__scrollbar";
      bar.setAttribute("aria-hidden", "true");
      bar.innerHTML =
        '<div class="c-form-privacy__scrollbar-track"></div><div class="c-form-privacy__scrollbar-thumb"></div>';
      box.appendChild(bar);
    }

    let track = bar.querySelector(".c-form-privacy__scrollbar-track");
    let thumb = bar.querySelector(".c-form-privacy__scrollbar-thumb");

    if (!track) {
      track = document.createElement("div");
      track.className = "c-form-privacy__scrollbar-track";
      bar.prepend(track);
    }

    if (!thumb) {
      thumb = document.createElement("div");
      thumb.className = "c-form-privacy__scrollbar-thumb";
      bar.appendChild(thumb);
    }

    return { bar, track, thumb };
  }
}

class GalleryModal {
  constructor(el) {
    this.roots = document.querySelectorAll('.' + el);
    if (!this.roots.length) return;

    this.durationMs = 300;
    this.reduceMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;
    this.activeDialog = null;
    this.closing = new WeakSet();
    this.state = new WeakMap();

    this.roots.forEach((root) => this.bindRoot(root));
  }

  bindRoot(root) {
    const dialog = root.querySelector('[data-gallery-modal]');
    const img = root.querySelector('[data-gallery-modal-img]');
    const caption = root.querySelector('[data-gallery-modal-caption]');
    const counter = root.querySelector('[data-gallery-counter]');
    if (!dialog || !img) return;

    this.state.set(dialog, {
      root,
      img,
      caption,
      counter,
      items: [],
      index: 0,
      targetIndex: 0,
      fading: false,
      fadeTimer: 0,
      onImgReady: null,
      scrollLocked: false,
      swipe: {
        active: false,
        pointerId: null,
        startX: 0,
        startY: 0,
        locked: null,
        suppressClick: false,
      },
    });

    img.addEventListener('dragstart', (event) => {
      event.preventDefault();
    });

    this.bindSwipe(dialog, root.querySelector('[data-gallery-swipe]') || img);
    this.bindOpenGuard(root, dialog);

    root.addEventListener('click', (event) => {
      const openTrigger = event.target.closest('[data-gallery-open]');
      if (openTrigger && root.contains(openTrigger)) {
        // スワイプ後の合成 click や Swiper の preventClicks を無視して開かない
        if (event.defaultPrevented || this.consumeOpenSuppressed(dialog)) {
          event.preventDefault();
          return;
        }
        event.preventDefault();
        this.open(dialog, openTrigger);
        return;
      }

      const closeTrigger = event.target.closest('[data-gallery-close]');
      if (closeTrigger && root.contains(closeTrigger)) {
        event.preventDefault();
        this.close(dialog);
        return;
      }

      const prevTrigger = event.target.closest('[data-gallery-prev]');
      if (prevTrigger && root.contains(prevTrigger)) {
        event.preventDefault();
        this.step(dialog, -1);
        return;
      }

      const nextTrigger = event.target.closest('[data-gallery-next]');
      if (nextTrigger && root.contains(nextTrigger)) {
        event.preventDefault();
        this.step(dialog, 1);
      }
    });

    dialog.addEventListener('click', (event) => {
      const state = this.state.get(dialog);
      if (state && state.swipe.suppressClick) {
        state.swipe.suppressClick = false;
        event.preventDefault();
        return;
      }

      if (
        event.target.closest(
          '[data-gallery-modal-img], [data-gallery-modal-caption], [data-gallery-prev], [data-gallery-next], [data-gallery-close], [data-gallery-counter]'
        )
      ) {
        return;
      }
      this.close(dialog);
    });

    // Esc の即閉じを止め、フェードアウトしてから閉じる
    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      this.close(dialog);
    });

    dialog.addEventListener('keydown', (event) => {
      if (!dialog.open && !dialog.hasAttribute('open')) return;
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.step(dialog, -1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.step(dialog, 1);
      }
    });

    dialog.addEventListener('close', () => {
      dialog.classList.remove('is-open', 'is-closing');
      this.closing.delete(dialog);
      if (this.activeDialog === dialog) {
        this.activeDialog = null;
      }
      const state = this.state.get(dialog);
      if (state) {
        this.unlockScroll(state);
        this.resetFade(state);
        state.img.classList.remove('is-switching');
        state.img.removeAttribute('src');
        state.img.alt = '';
        this.applyCaption(state, '');
        state.items = [];
        state.index = 0;
        state.targetIndex = 0;
        if (state.counter) {
          state.counter.textContent = '1 / 1';
        }
        this.resetSwipe(state);
      }
    });
  }

  // スライド操作中の指離れでモーダルが開かないよう、移動量で開く操作を抑止する
  bindOpenGuard(root, dialog) {
    const state = this.state.get(dialog);
    if (!state) return;

    state.openGuard = {
      pointerId: null,
      startX: 0,
      startY: 0,
      suppress: false,
    };

    const moveThreshold = 8;

    root.addEventListener('pointerdown', (event) => {
      const openTrigger = event.target.closest('[data-gallery-open]');
      if (!openTrigger || !root.contains(openTrigger)) return;
      if (event.isPrimary === false) return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;

      state.openGuard.pointerId = event.pointerId;
      state.openGuard.startX = event.clientX;
      state.openGuard.startY = event.clientY;
      state.openGuard.suppress = false;
    });

    root.addEventListener('pointermove', (event) => {
      const guard = state.openGuard;
      if (!guard || guard.pointerId === null) return;
      if (event.pointerId !== guard.pointerId || guard.suppress) return;

      const dx = event.clientX - guard.startX;
      const dy = event.clientY - guard.startY;
      if (Math.abs(dx) > moveThreshold || Math.abs(dy) > moveThreshold) {
        guard.suppress = true;
      }
    });

    const endPointer = (event) => {
      const guard = state.openGuard;
      if (!guard || guard.pointerId === null) return;
      if (event.pointerId !== guard.pointerId) return;
      guard.pointerId = null;
    };

    root.addEventListener('pointerup', endPointer);
    root.addEventListener('pointercancel', (event) => {
      const guard = state.openGuard;
      if (!guard || guard.pointerId === null) return;
      if (event.pointerId !== guard.pointerId) return;
      guard.pointerId = null;
      guard.suppress = false;
    });
  }

  consumeOpenSuppressed(dialog) {
    const state = this.state.get(dialog);
    if (!state || !state.openGuard || !state.openGuard.suppress) return false;
    state.openGuard.suppress = false;
    return true;
  }

  lockScroll(state) {
    if (!state || state.scrollLocked) return;
    if (typeof window.lockBodyScroll !== 'function') return;
    window.lockBodyScroll();
    state.scrollLocked = true;
  }

  unlockScroll(state) {
    if (!state || !state.scrollLocked) return;
    if (typeof window.unlockBodyScroll === 'function') {
      window.unlockBodyScroll();
    }
    state.scrollLocked = false;
  }

  bindSwipe(dialog, target) {
    if (!target) return;

    const isControl = (event) =>
      !!event.target.closest(
        '[data-gallery-prev], [data-gallery-next], [data-gallery-close]'
      );

    target.addEventListener('pointerdown', (event) => {
      if (isControl(event)) return;
      this.onSwipeStart(dialog, event);
    });

    target.addEventListener(
      'pointermove',
      (event) => {
        this.onSwipeMove(dialog, target, event);
      },
      { passive: false }
    );

    target.addEventListener('pointerup', (event) => {
      this.onSwipeEnd(dialog, event);
    });

    target.addEventListener('pointercancel', () => {
      const state = this.state.get(dialog);
      if (state) this.resetSwipe(state);
    });
  }

  onSwipeStart(dialog, event) {
    const state = this.state.get(dialog);
    if (!state || this.closing.has(dialog)) return;
    if (!dialog.open && !dialog.hasAttribute('open')) return;
    if (event.pointerType === 'mouse' && event.button !== 0) return;
    if (event.isPrimary === false) return;

    if (event.pointerType === 'mouse') {
      event.preventDefault();
    }

    state.swipe.active = true;
    state.swipe.pointerId = event.pointerId;
    state.swipe.startX = event.clientX;
    state.swipe.startY = event.clientY;
    state.swipe.locked = null;
    state.swipe.suppressClick = false;
  }

  onSwipeMove(dialog, target, event) {
    const state = this.state.get(dialog);
    if (!state || !state.swipe.active) return;
    if (event.pointerId !== state.swipe.pointerId) return;

    const dx = event.clientX - state.swipe.startX;
    const dy = event.clientY - state.swipe.startY;
    const lockThreshold = 8;

    if (
      state.swipe.locked === null &&
      (Math.abs(dx) > lockThreshold || Math.abs(dy) > lockThreshold)
    ) {
      state.swipe.locked = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      if (state.swipe.locked === 'x') {
        dialog.classList.add('is-swiping');
        if (target.setPointerCapture) {
          target.setPointerCapture(event.pointerId);
        }
      }
    }

    if (state.swipe.locked === 'x') {
      event.preventDefault();
    }
  }

  onSwipeEnd(dialog, event) {
    const state = this.state.get(dialog);
    if (!state || !state.swipe.active) return;
    if (event.pointerId !== state.swipe.pointerId) return;

    const dx = event.clientX - state.swipe.startX;
    const wasHorizontal = state.swipe.locked === 'x';
    const swipeThreshold = 40;

    this.resetSwipe(state);

    if (!wasHorizontal || Math.abs(dx) < swipeThreshold) return;

    state.swipe.suppressClick = true;
    this.step(dialog, dx < 0 ? 1 : -1);
  }

  resetSwipe(state) {
    if (!state || !state.swipe) return;
    state.swipe.active = false;
    state.swipe.pointerId = null;
    state.swipe.startX = 0;
    state.swipe.startY = 0;
    state.swipe.locked = null;
    const dialog = state.img && state.img.closest('[data-gallery-modal]');
    if (dialog) {
      dialog.classList.remove('is-swiping');
    }
  }

  getItems(root, trigger) {
    const group = trigger.closest('[data-gallery-group]') || root;
    return Array.from(group.querySelectorAll('[data-gallery-open]')).filter(
      (el) =>
        !el.closest('.swiper-slide-duplicate') &&
        !el.closest('[data-job-slider-clone]')
    );
  }

  wrapIndex(index, len) {
    return ((index % len) + len) % len;
  }

  applyItem(state, index) {
    const len = state.items.length;
    state.index = this.wrapIndex(index, len);
    state.targetIndex = state.index;
    const trigger = state.items[state.index];
    const captionText = (trigger.getAttribute('data-full-caption') || '').trim();
    state.img.src = trigger.getAttribute('data-full-src') || '';
    state.img.alt = trigger.getAttribute('data-full-alt') || captionText;
    this.applyCaption(state, captionText);

    if (state.counter) {
      state.counter.textContent = state.index + 1 + ' / ' + len;
    }
  }

  applyCaption(state, text) {
    if (!state.caption) return;

    state.caption.textContent = text;
    if (text) {
      state.caption.removeAttribute('hidden');
    } else {
      state.caption.setAttribute('hidden', '');
    }
  }

  resetFade(state) {
    state.fading = false;
    if (state.fadeTimer) {
      window.clearTimeout(state.fadeTimer);
      state.fadeTimer = 0;
    }
    if (state.onImgReady) {
      state.img.removeEventListener('load', state.onImgReady);
      state.img.removeEventListener('error', state.onImgReady);
      state.onImgReady = null;
    }
  }

  waitOpacity(img, done) {
    if (this.reduceMotion) {
      done();
      return;
    }

    let finished = false;
    const finish = () => {
      if (finished) return;
      finished = true;
      img.removeEventListener('transitionend', onEnd);
      done();
    };

    const onEnd = (event) => {
      if (event.target !== img || event.propertyName !== 'opacity') return;
      finish();
    };

    img.addEventListener('transitionend', onEnd);
    window.setTimeout(finish, this.durationMs + 50);
  }

  waitImage(state, done) {
    const img = state.img;
    if (this.reduceMotion || (img.complete && img.naturalWidth > 0)) {
      done();
      return;
    }

    const onReady = () => {
      if (state.onImgReady !== onReady) return;
      state.onImgReady = null;
      img.removeEventListener('load', onReady);
      img.removeEventListener('error', onReady);
      done();
    };

    state.onImgReady = onReady;
    img.addEventListener('load', onReady);
    img.addEventListener('error', onReady);
  }

  fadeToItem(dialog, index) {
    const state = this.state.get(dialog);
    if (!state) return;

    const img = state.img;
    const alreadyHidden = img.classList.contains('is-switching');
    state.fading = true;
    state.targetIndex = index;

    const afterOut = () => {
      if (this.closing.has(dialog) || (!dialog.open && !dialog.hasAttribute('open'))) {
        return;
      }

      this.applyItem(state, state.targetIndex);

      const afterIn = () => {
        if (this.closing.has(dialog)) return;
        if (state.targetIndex !== state.index) {
          this.fadeToItem(dialog, state.targetIndex);
          return;
        }
        state.fading = false;
      };

      const reveal = () => {
        if (this.closing.has(dialog)) return;
        this.waitOpacity(img, afterIn);
        img.classList.remove('is-switching');
      };

      this.waitImage(state, () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(reveal);
        });
      });
    };

    if (alreadyHidden) {
      afterOut();
      return;
    }

    this.waitOpacity(img, afterOut);
    img.classList.add('is-switching');
  }

  showItem(dialog, index, fade) {
    const state = this.state.get(dialog);
    if (!state || !state.items.length) return;

    const next = this.wrapIndex(index, state.items.length);

    if (!fade || this.reduceMotion) {
      this.resetFade(state);
      this.applyItem(state, next);
      state.img.classList.remove('is-switching');
      return;
    }

    if (next === state.index && !state.fading && state.img.getAttribute('src')) {
      return;
    }

    if (state.fading) {
      state.targetIndex = next;
      return;
    }

    this.fadeToItem(dialog, next);
  }

  step(dialog, delta) {
    const state = this.state.get(dialog);
    if (!state || !state.items.length || this.closing.has(dialog)) return;

    const from = state.fading ? state.targetIndex : state.index;
    this.showItem(dialog, from + delta, true);
  }

  open(dialog, trigger) {
    const state = this.state.get(dialog);
    if (!state || this.closing.has(dialog)) return;

    const items = this.getItems(state.root, trigger);
    const src = trigger.getAttribute('data-full-src') || '';
    if (!src || !items.length) return;

    state.items = items;
    let index = items.indexOf(trigger);
    if (index < 0) {
      index = items.findIndex(
        (el) => el.getAttribute('data-full-src') === src
      );
    }
    this.showItem(dialog, index >= 0 ? index : 0, false);

    dialog.classList.remove('is-closing');

    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) {
        dialog.showModal();
        this.lockScroll(state);
      }
    } else if (!dialog.hasAttribute('open')) {
      dialog.setAttribute('open', '');
      this.lockScroll(state);
    }

    this.activeDialog = dialog;

    if (this.reduceMotion) {
      dialog.classList.add('is-open');
      return;
    }

    // 開いた直後に opacity 0 → 1 へ遷移させる
    dialog.classList.remove('is-open');
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        dialog.classList.add('is-open');
      });
    });
  }

  close(dialog) {
    if (!dialog || this.closing.has(dialog)) return;
    if (!dialog.open && !dialog.hasAttribute('open')) return;

    const state = this.state.get(dialog);
    if (state) {
      this.resetFade(state);
    }

    if (this.reduceMotion || !dialog.classList.contains('is-open')) {
      this.finishClose(dialog);
      return;
    }

    this.closing.add(dialog);
    dialog.classList.add('is-closing');
    dialog.classList.remove('is-open');

    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      dialog.removeEventListener('transitionend', onEnd);
      window.clearTimeout(fallbackId);
      this.finishClose(dialog);
    };

    const onEnd = (event) => {
      if (event.target !== dialog || event.propertyName !== 'opacity') return;
      finish();
    };

    dialog.addEventListener('transitionend', onEnd);
    const fallbackId = window.setTimeout(finish, this.durationMs + 50);
  }

  finishClose(dialog) {
    if (typeof dialog.close === 'function' && dialog.open) {
      dialog.close();
      return;
    }

    dialog.removeAttribute('open');
    dialog.dispatchEvent(new Event('close'));
  }
}

class Header {
  constructor(el, opt) {
    this.el = '.' + el;
    this.$el = $(this.el);
    this.threshold = (opt && opt.threshold) || 500;
    this.compactClass = 'is-compact';
    this.pcQuery = window.matchMedia('(min-width: 768px)');

    if (this.$el.length > 0) {
      this.event();
    }
  }

  event() {
    const update = () => {
      const shouldCompact = this.pcQuery.matches && window.scrollY >= this.threshold;

      this.$el.toggleClass(this.compactClass, shouldCompact);
    };

    $(window).on('scroll', update);
    $(window).on('resize', update);
    update();
  }
}

// ------------------------------------------
// imgタグに「js-parallax」クラス、そのimgタグに要素をラップしてheightを指定すると、画像がはみ出た分が動く
// 「data-scrub」属性に数字を入れると、動きの滑らかさが変わる
// ------------------------------------------
class ImgParallax {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    let cls = this.el;
    let para_ele = document.querySelectorAll("." + this.el);
    para_ele.forEach((ele, index)=> {
      let property,scrub;

      $(ele).css({
        'object-fit':'cover',
        'object-position':'50% 0%',
        'width':'100%',
        'height':'100%',
      })

      property = '50% 100%';
      scrub = $(ele).data('scrub') ? $(ele).data('scrub') : 3;

      ele.classList.add(cls + index);
      gsap.to('.' + cls + index, {
        objectPosition: property,
        scrollTrigger: {
          trigger: '.' + cls + index, // 要素がビューポートに入ったときにアニメーション開始
          start: 'top bottom',
          end: 'bottom top',
          scrub: scrub,
          merker: true,
        }
      })
    })
  }
}

/**
 * インターンシップ入力ページで、確認画面から戻ったときに
 * 申し込みフォーム（#apply）へスクロールする。
 */
class InternshipApplyScroll {
  constructor(opt = {}) {
    this.targetId = opt.targetId || 'apply';
    this.target = document.getElementById(this.targetId);
    if (!this.target) return;
    if (!this.isConfirmReferrer()) return;

    const run = () => this.scrollToApply();
    if (document.readyState === 'complete') {
      run();
    } else {
      window.addEventListener('load', run, { once: true });
    }
  }

  isConfirmReferrer() {
    const ref = document.referrer;
    if (!ref) return false;

    let url;
    try {
      url = new URL(ref);
    } catch (e) {
      return false;
    }

    if (url.origin !== window.location.origin) return false;

    const path = url.pathname;
    return (
      path.indexOf('entry-confirm') !== -1 ||
      path.indexOf('internship-confirm') !== -1 ||
      (path.indexOf('internship') !== -1 && path.indexOf('confirm') !== -1)
    );
  }

  scrollToApply() {
    const path = window.location.pathname + window.location.search;
    if (window.location.hash !== '#' + this.targetId) {
      history.replaceState(null, '', path + '#' + this.targetId);
    }
    this.target.scrollIntoView({ block: 'start' });
  }
}

class InterviewListSlider {
  constructor(el) {
    this.roots = document.querySelectorAll('.' + el);
    if (!this.roots.length || typeof Swiper === 'undefined') return;

    this.minSlides = 4;
    this.reduceMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;
    this.canHover = window.matchMedia('(hover: hover)').matches;
    this.spQuery = window.matchMedia('(max-width: 767px)');

    this.items = Array.from(this.roots)
      .map((root) => {
        const viewport = root.querySelector('.c-interview-list__viewport');
        const slides = Array.from(root.querySelectorAll('.swiper-slide'));
        return {
          root,
          viewport,
          slides,
          pagination: root.querySelector('.c-interview-list__pagination'),
          count: slides.length,
          swiper: null,
        };
      })
      .filter((item) => item.viewport && item.count >= this.minSlides);

    this.resizeQueued = false;
    this.spQuery.addEventListener('change', () => this.update());
    window.addEventListener('resize', () => {
      if (this.resizeQueued) return;
      this.resizeQueued = true;
      window.requestAnimationFrame(() => {
        this.resizeQueued = false;
        this.updateSpace();
      });
    });
    this.update();
  }

  spaceBetween() {
    const rem = parseFloat(
      getComputedStyle(document.documentElement).fontSize
    );
    if (Number.isNaN(rem)) {
      return this.spQuery.matches ? 24 : 50;
    }
    return this.spQuery.matches ? rem * 2.4 : rem * 5;
  }

  update() {
    this.items.forEach((item) => {
      if (item.swiper) {
        item.swiper.destroy(true, true);
        item.swiper = null;
      }
      item.swiper = new Swiper(item.viewport, this.options(item));
    });
  }

  updateSpace() {
    const space = this.spaceBetween();
    this.items.forEach((item) => {
      if (!item.swiper) return;
      item.swiper.params.spaceBetween = space;
      item.swiper.update();
    });
  }

  options(item) {
    const isSp = this.spQuery.matches;
    const canSlide = item.count > (isSp ? 1 : 3);

    return {
      // SP: カード幅は CSS の 30rem。auto + 中央寄せで左右 2.4rem すきまの隣カードを覗かせる
      slidesPerView: isSp ? 'auto' : 3,
      centeredSlides: isSp,
      spaceBetween: this.spaceBetween(),
      speed: this.reduceMotion ? 0 : 600,
      loop: true,
      loopAddBlankSlides: false,
      watchOverflow: true,
      threshold: 8,
      preventClicks: true,
      preventClicksPropagation: true,
      allowTouchMove: canSlide,
      grabCursor: canSlide && this.canHover,
      observer: true,
      observeParents: true,
      pagination: {
        el: item.pagination,
        clickable: true,
        bulletClass: 'c-interview-list__pagination-bullet',
        bulletActiveClass: 'is-active',
      },
      a11y: {
        enabled: true,
        slideRole: null,
        paginationBulletMessage: '{{index}}番目へ',
      },
    };
  }
}

class InterviewSlider {
  constructor(el) {
    this.root = document.querySelector('.' + el);

    if (!this.root) {
      return;
    }

    this.mainImage = this.root.querySelector('[data-interview-main-image]');
    this.mainSource = this.root.querySelector('[data-interview-main-source]');
    this.swipeTargets = Array.from(this.root.querySelectorAll('[data-interview-swipe]'));
    this.number = this.root.querySelector('[data-interview-number]');
    this.role = this.root.querySelector('[data-interview-role]');
    this.quote = this.root.querySelector('[data-interview-quote]');
    this.profile = this.root.querySelector('[data-interview-profile]');
    this.moreLink = this.root.querySelector('[data-interview-more]');
    this.spotlight = this.root.querySelector('.p-top__interview-spotlight');
    this.viewport = this.root.querySelector('.p-top__interview-thumbnails');
    this.track = this.root.querySelector('[data-interview-thumbnail-track]');
    this.thumbnails = Array.from(this.root.querySelectorAll('[data-interview-thumbnail]'));
    this.prevButton = this.root.querySelector('[data-interview-gallery-prev]');
    this.nextButton = this.root.querySelector('[data-interview-gallery-next]');
    this.thumbnailPage = 0;
    this.currentIndex = 0;
    this.isAnimating = false;
    this.timeline = null;
    this.spotlightParallaxFrame = null;
    this.setSpotlightY = null;
    this.swipe = {
      active: false,
      startX: 0,
      startY: 0,
      locked: null,
    };

    this.event();
    this.setActiveThumbnail(0);
    this.updateContent(0);
    this.updateThumbnailPosition();
  }

  event() {
    this.thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', () => {
        this.show(index);
      });
    });

    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => {
        this.showPrevSlide();
      });
    }

    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => {
        this.showNextSlide();
      });
    }

    window.addEventListener('resize', () => {
      this.updateThumbnailPosition();
    });

    this.setupSwipe();
    this.setupSpotlightParallax();
  }

  isSpViewport() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  setupSwipe() {
    if (!this.swipeTargets.length) {
      return;
    }

    this.swipeTargets.forEach((target) => {
      target.addEventListener('touchstart', (event) => {
        this.onSwipeStart(event);
      }, { passive: true });

      target.addEventListener('touchmove', (event) => {
        this.onSwipeMove(event);
      }, { passive: false });

      target.addEventListener('touchend', (event) => {
        this.onSwipeEnd(event);
      });

      target.addEventListener('touchcancel', () => {
        this.resetSwipe();
      });
    });
  }

  isSwipeIgnoredTarget(event) {
    return Boolean(event.target.closest('a, button'));
  }

  onSwipeStart(event) {
    if (!this.isSpViewport() || event.touches.length !== 1) {
      return;
    }

    if (this.isSwipeIgnoredTarget(event)) {
      return;
    }

    const touch = event.touches[0];
    this.swipe.active = true;
    this.swipe.startX = touch.clientX;
    this.swipe.startY = touch.clientY;
    this.swipe.locked = null;
  }

  onSwipeMove(event) {
    if (!this.swipe.active || event.touches.length !== 1) {
      return;
    }

    const touch = event.touches[0];
    const dx = touch.clientX - this.swipe.startX;
    const dy = touch.clientY - this.swipe.startY;
    const lockThreshold = 8;

    if (this.swipe.locked === null && (Math.abs(dx) > lockThreshold || Math.abs(dy) > lockThreshold)) {
      this.swipe.locked = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
    }

    if (this.swipe.locked === 'x') {
      event.preventDefault();
    }
  }

  onSwipeEnd(event) {
    if (!this.swipe.active) {
      return;
    }

    const touch = event.changedTouches[0];

    if (!touch) {
      this.resetSwipe();
      return;
    }

    const dx = touch.clientX - this.swipe.startX;
    const wasHorizontal = this.swipe.locked === 'x';
    const swipeThreshold = 40;

    this.resetSwipe();

    if (!wasHorizontal || Math.abs(dx) < swipeThreshold) {
      return;
    }

    if (dx < 0) {
      this.showNextSlide();
      return;
    }

    this.showPrevSlide();
  }

  resetSwipe() {
    this.swipe.active = false;
    this.swipe.startX = 0;
    this.swipe.startY = 0;
    this.swipe.locked = null;
  }

  setupSpotlightParallax() {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!this.spotlight || reduceMotion) {
      return;
    }

    if (typeof gsap !== 'undefined') {
      this.setSpotlightY = gsap.quickTo(this.spotlight, 'y', {
        duration: 1.2,
        ease: 'power3.out',
      });
    }

    const requestUpdate = () => {
      if (this.spotlightParallaxFrame !== null) {
        return;
      }

      this.spotlightParallaxFrame = window.requestAnimationFrame(() => {
        this.spotlightParallaxFrame = null;
        this.updateSpotlightParallax();
      });
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    requestUpdate();
  }

  updateSpotlightParallax() {
    const rootRect = this.root.getBoundingClientRect();
    const viewportCenter = window.innerHeight / 2;
    const rootCenter = rootRect.top + (rootRect.height / 2);
    const travelRange = (window.innerHeight + rootRect.height) / 2;
    const progress = (viewportCenter - rootCenter) / travelRange;
    const clampedProgress = Math.max(-1, Math.min(1, progress));
    const rootFontSize = parseFloat(window.getComputedStyle(document.documentElement).fontSize);
    const offset = clampedProgress * rootFontSize * 4;

    if (this.setSpotlightY) {
      this.setSpotlightY(offset);
      return;
    }

    this.spotlight.style.transform = `translate3d(0, ${offset}px, 0)`;
  }

  show(index) {
    const thumbnail = this.thumbnails[index];

    if (!thumbnail || index === this.currentIndex || this.isAnimating) {
      return;
    }

    this.setActiveThumbnail(index);

    if (typeof gsap === 'undefined' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.updateContent(index);
      return;
    }

    this.isAnimating = true;

    this.preloadImage(this.slideImageSrc(thumbnail)).then(() => {
      this.animateSlideChange(index);
    });
  }

  animateSlideChange(index) {
    const copy = this.root.querySelector('.p-top__interview-copy');
    const maskTargets = [this.mainImage, copy].filter(Boolean);

    this.timeline = gsap.timeline({
      defaults: {
        duration: 0.5,
        ease: 'power2.inOut',
      },
      onComplete: () => {
        this.isAnimating = false;
        this.timeline = null;
      },
    });

    this.timeline
      .addLabel('hide')
      .to(this.mainImage, {
        clipPath: 'inset(0 0 0 100%)',
      }, 'hide')
      .to(copy, {
        clipPath: 'inset(0 0 0 100%)',
      }, 'hide')
      .call(() => {
        this.updateContent(index);
        gsap.set(maskTargets, {
          clipPath: 'inset(0 100% 0 0)',
        });
      }, null, 'hide+=0.5')
      .addLabel('show', 'hide+=0.5')
      .to(this.mainImage, {
        clipPath: 'inset(0 0% 0 0)',
        ease: 'power3.out',
      }, 'show')
      .to(copy, {
        clipPath: 'inset(0 0% 0 0)',
        ease: 'power3.out',
      }, 'show');
  }

  slideImageSrc(thumbnail) {
    if (this.isSpViewport() && thumbnail.dataset.interviewImageSp) {
      return thumbnail.dataset.interviewImageSp;
    }
    return thumbnail.dataset.interviewImage;
  }

  preloadImage(src) {
    return new Promise((resolve) => {
      const image = new Image();

      image.onload = resolve;
      image.onerror = resolve;
      image.src = src;
    });
  }

  setActiveThumbnail(index) {
    this.thumbnails.forEach((item, itemIndex) => {
      const isActive = itemIndex === index;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-pressed', String(isActive));
    });

    this.currentIndex = index;
    this.syncThumbnailPage(index);
  }

  updateContent(index) {
    const thumbnail = this.thumbnails[index];

    if (!thumbnail) {
      return;
    }

    this.mainImage.src = thumbnail.dataset.interviewImage;
    if (this.mainSource) {
      this.mainSource.srcset = thumbnail.dataset.interviewImageSp || thumbnail.dataset.interviewImage;
    }
    this.mainImage.alt = thumbnail.dataset.interviewAlt;
    this.number.textContent = thumbnail.dataset.interviewNumber;
    this.role.textContent = thumbnail.dataset.interviewRole;
    this.quote.textContent = thumbnail.dataset.interviewQuote;
    this.profile.textContent = thumbnail.dataset.interviewProfile;

    if (this.moreLink && thumbnail.dataset.interviewUrl) {
      this.moreLink.setAttribute('href', thumbnail.dataset.interviewUrl);
    }
  }

  showPrevSlide() {
    this.show(this.currentIndex - 1);
  }

  showNextSlide() {
    this.show(this.currentIndex + 1);
  }

  syncThumbnailPage(index) {
    const page = Math.floor(index / this.getPageSize());

    if (page === this.thumbnailPage) {
      this.updateArrowVisibility();
      return;
    }

    this.thumbnailPage = page;
    this.updateThumbnailPosition();
  }

  getPageSize() {
    const step = this.getThumbnailStep();

    if (!step || !this.viewport) {
      return 4;
    }

    return Math.max(1, Math.round(this.viewport.getBoundingClientRect().width / step));
  }

  getThumbnailPageCount() {
    return Math.max(1, Math.ceil(this.thumbnails.length / this.getPageSize()));
  }

  updateThumbnailPosition() {
    if (!this.track || !this.viewport) {
      return;
    }

    const pageCount = this.getThumbnailPageCount();

    if (this.thumbnailPage >= pageCount) {
      this.thumbnailPage = pageCount - 1;
    }

    if (this.thumbnailPage < 0) {
      this.thumbnailPage = 0;
    }

    const offset = this.thumbnailPage * this.getPageSize() * this.getThumbnailStep();
    this.track.style.transform = `translateX(-${offset}px)`;
    this.updateArrowVisibility();
  }

  updateArrowVisibility() {
    const hasPrev = this.currentIndex > 0;
    const hasNext = this.currentIndex < this.thumbnails.length - 1;

    if (this.prevButton) {
      this.prevButton.classList.toggle('is-hidden', !hasPrev);
      this.prevButton.setAttribute('aria-hidden', String(!hasPrev));
      this.prevButton.tabIndex = hasPrev ? 0 : -1;
    }

    if (this.nextButton) {
      this.nextButton.classList.toggle('is-hidden', !hasNext);
      this.nextButton.setAttribute('aria-hidden', String(!hasNext));
      this.nextButton.tabIndex = hasNext ? 0 : -1;
    }
  }

  getThumbnailStep() {
    if (this.thumbnails.length >= 2) {
      const step = this.thumbnails[1].offsetLeft - this.thumbnails[0].offsetLeft;

      if (step > 0) {
        return step;
      }
    }

    return this.getThumbnailWidth();
  }

  getThumbnailWidth() {
    const firstThumbnail = this.thumbnails[0];

    if (!firstThumbnail) {
      return 0;
    }

    return firstThumbnail.getBoundingClientRect().width;
  }
}

class InviewEvent {
  constructor(el, opt){
    $('.js-load-inview').animate({'opacity': '1'});
    this.el = "." + el;
    this.all = this.el + '-all';
    this.eachUp = this.el + '-each';
    this.eachItem = this.el + '-eachItem';
    this.eachItemFast = this.el + '-eachItem-fast';
    this.eachItemDelay = this.el + '-eachItem-delay';
    if($(this.el).length > 0){
      this.event();
    }
  }
  event() {
    let options = {
      threshold: [0, 0.05, 0.1, 1]
    }
    let optionsAll = {
      threshold: [0, 0.9, 1]
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.05){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          if(item.classList.contains('js-inview-lottie')){
            this.inviewLottie(item);
          }
          observerEnter.unobserve(item);
        }
      });
    }, options);
    const observerAll = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.9){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          observerAll.unobserve(item);
        } else {
          item.classList.remove('is-inview');
        }
      });
    }, optionsAll);
    const inviewItem = document.querySelectorAll(this.el);
    const inviewAllItem = document.querySelectorAll(this.all);
    inviewItem.forEach((e)=>{
      observerEnter.observe(e);
    });
    inviewAllItem.forEach((e)=>{
      observerAll.observe(e);
    });
  }
  inviewEachUp(item){
    $(item).find(this.eachItem).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.2 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemFast).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.1 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemDelay).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.5 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
  }
  inviewLottie(item){
    if($(item).hasClass('js-lottie-flow')) {
      lottie.flow();
    }
    if($(item).hasClass('js-lottie-no01')) {
      lottie.no01();
    }
    if($(item).hasClass('js-lottie-no02')) {
      lottie.no02();
    }
    if($(item).hasClass('js-lottie-no03')) {
      lottie.no03();
    }
    if($(item).hasClass('js-lottie-no04')) {
      lottie.no04();
    }
    if($(item).hasClass('js-lottie-no05')) {
      lottie.no05();
    }
    if($(item).hasClass('js-lottie-no06')) {
      lottie.no06();
    }
    if($(item).hasClass('js-lottie-no07')) {
      lottie.no07();
    }
  }
}

class JobSlider {
  constructor(el) {
    this.roots = document.querySelectorAll('.' + el);
    if (!this.roots.length || typeof Swiper === 'undefined') return;

    this.reduceMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;
    this.canHover = window.matchMedia('(hover: hover)').matches;
    this.spQuery = window.matchMedia('(max-width: 767px)');
    this.minLoopSlides = 4;

    // 同じ構造が3事業ぶん並ぶので、ページネーションは自分と同じ親の中から拾う
    this.items = Array.from(this.roots)
      .map((root) => {
        const slides = Array.from(root.querySelectorAll('.swiper-slide'));
        return {
          root,
          slides,
          track: root.querySelector('.swiper-wrapper'),
          pagination: root.parentElement.querySelector('.js-job-pagination'),
          count: slides.length,
          repeat: 1,
          swiper: null,
        };
      })
      .filter((item) => item.count > 0);

    this.items.forEach((item) => this.bindPaginationKeys(item));
    this.spQuery.addEventListener('change', () => this.update());
    this.update();
  }

  // type: "custom" のドットは Swiper の a11y の対象外で Enter / Space が効かない。
  // 既定のドットと操作感を揃える。要素は作り直されないので一度だけ張ればよい
  bindPaginationKeys(item) {
    if (!item.pagination) return;

    item.pagination.addEventListener('keydown', (e) => {
      const type = item.swiper && item.swiper.params.pagination.type;
      if (type !== 'custom') return;
      if (e.key !== 'Enter' && e.key !== ' ') return;

      const bullet = e.target.closest(
        '.p-business__job-works-pagination-bullet'
      );
      if (!bullet) return;

      e.preventDefault();
      bullet.click();
    });
  }

  // loop は breakpoints から切り替えられないため、SP / PC で作り直す
  update() {
    this.items.forEach((item) => {
      if (item.swiper) {
        item.swiper.destroy(true, true);
      }
      item.repeat = this.repeatCount(item);
      // 記事が2件で loop させると中央の左右に同じ記事が並んでしまうため loop をやめる
      item.bounded = this.spQuery.matches && item.count === 2;
      // 両端揃えのときは画面端に付かないよう、CSS 側で左右の余白を作る
      item.root.classList.toggle('is-bounded', item.bounded);
      this.syncClones(item);
      item.swiper = new Swiper(item.root, this.options(item));
    });
  }

  // SP は中央の1枚の左右を覗かせるデザインなので、記事が少なくても loop を成立させる。
  // 2件以下は loop させないので複製もしない
  repeatCount(item) {
    if (!this.spQuery.matches) return 1;
    if (item.count < 3 || item.count >= this.minLoopSlides) return 1;
    return Math.ceil(this.minLoopSlides / item.count);
  }

  // 必要枚数はブレイクポイントで変わるので、複製は毎回作り直す
  syncClones(item) {
    item.track
      .querySelectorAll('[data-job-slider-clone]')
      .forEach((clone) => clone.remove());

    for (let i = 1; i < item.repeat; i += 1) {
      item.slides.forEach((slide) => {
        const clone = slide.cloneNode(true);
        clone.setAttribute('data-job-slider-clone', '');
        clone.removeAttribute('data-swiper-slide-index');
        item.track.appendChild(clone);
      });
    }
  }

  options(item) {
    const isSp = this.spQuery.matches;
    const total = item.count * item.repeat;
    const perView = isSp ? 1 : 3;
    const canSlide = total > perView;

    return {
      slidesPerView: isSp ? 'auto' : 3,
      centeredSlides: isSp,
      centeredSlidesBounds: item.bounded,
      // SP: 15 / 400 = 3.75%　PC: 25 / 800 = 3.125%
      spaceBetween: isSp ? '3.75%' : '3.125%',
      speed: this.reduceMotion ? 0 : 600,
      loop: canSlide && !item.bounded,
      loopAddBlankSlides: false,
      allowTouchMove: canSlide,
      grabCursor: canSlide && this.canHover,
      threshold: 8,
      preventClicks: true,
      preventClicksPropagation: true,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      pagination: this.pagination(item),
      a11y: {
        enabled: true,
        slideRole: null,
        // カードにフォーカスが移ったとき、
        // タブ移動が同じカードを巡り続けてスライダーから抜けられなくなるので切る
        scrollOnFocus: false,
        paginationBulletMessage: '{{index}}番目の施工事例へ',
      },
      on: {
        touchMove: (swiper, e) => this.limitDragToOneSlide(swiper, e),
      },
    };
  }

  // 1回の操作で1枚ぶんまでしか引っ張れないようにする
  limitDragToOneSlide(swiper, e) {
    const grid = swiper.slidesGrid;
    if (!grid || grid.length < 2) return;

    const i = swiper.activeIndex;
    const step = i < grid.length - 1 ? grid[i + 1] - grid[i] : grid[i] - grid[i - 1];
    const limit = step * 0.9;

    const point =
      e.targetTouches && e.targetTouches.length ? e.targetTouches[0] : e;
    const diff = point.pageX - swiper.touches.startX;
    if (Math.abs(diff) <= limit) return;

    swiper.touches.startX = point.pageX - (diff > 0 ? limit : -limit);
  }

  pagination(item) {
    const base = {
      el: item.pagination,
      clickable: true,
      bulletClass: 'p-business__job-works-pagination-bullet',
      bulletActiveClass: 'is-active',
    };
    if (item.repeat === 1) return base;

    // 複製したぶんはドットに出さず、記事の実数だけ並べる。
    return Object.assign({}, base, {
      type: 'custom',
      renderCustom: (swiper, current) => {
        const active = (current - 1) % item.count;
        let html = '';
        for (let i = 0; i < item.count; i += 1) {
          html +=
            `<span class="${base.bulletClass}${i === active ? ' is-active' : ''}"` +
            ` role="button" tabindex="0" aria-label="${i + 1}番目の施工事例へ"` +
            `${i === active ? ' aria-current="true"' : ''}></span>`;
        }
        return html;
      },
    });
  }
}

class MvSlider {
  constructor(el, opt) {
    this.root = document.querySelector('.' + el);
    if (!this.root) return;

    this.interval = (opt && opt.interval) || 4160;
    this.duration = (opt && opt.duration) || 0.7;
    this.overlap = (opt && opt.overlap) || 0.2;
    this.gap = (opt && opt.gap) || 0.3;
    this.frames = Array.from(
      this.root.querySelectorAll('[data-mv-layer="frame"]')
    );
    this.people = Array.from(
      this.root.querySelectorAll('[data-mv-layer="people"]')
    );
    this.count = Math.min(this.frames.length, this.people.length);
    this.current = 0;
    this.busy = false;
    this.timer = null;
    this.reduceMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    if (this.count < 2) return;

    this.setup();
    this.schedule();
  }

  setup() {
    this.frames.forEach((frame, index) => {
      gsap.set(frame, {
        clipPath: 'none',
        opacity: index === this.current ? 1 : 0,
      });
    });

    this.people.forEach((person, index) => {
      gsap.set(person, {
        opacity: index === this.current ? 1 : 0,
      });
    });
  }

  schedule() {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.next();
    }, this.interval);
  }

  next() {
    if (this.busy || this.count < 2) return;

    const from = this.current;
    const to = (from + 1) % this.count;
    this.goTo(from, to);
  }

  setActive(from, to) {
    this.frames[from].classList.remove('is-active');
    this.people[from].classList.remove('is-active');
    this.frames[to].classList.add('is-active');
    this.people[to].classList.add('is-active');
    this.current = to;
  }

  goTo(from, to) {
    this.busy = true;

    if (this.reduceMotion) {
      gsap.set(this.people[from], { opacity: 0 });
      gsap.set(this.frames[from], { clipPath: 'none', opacity: 0 });
      gsap.set(this.frames[to], { clipPath: 'none', opacity: 1 });
      gsap.set(this.people[to], { opacity: 1 });
      this.setActive(from, to);
      this.busy = false;
      this.schedule();
      return;
    }

    const tl = gsap.timeline({
      onComplete: () => {
        this.setActive(from, to);
        this.busy = false;
        this.schedule();
      },
    });

    // 人物 → 背景（overlap 重なり）で消し、gap 空けてから背景 → 人物で出す
    tl.to(this.people[from], {
      opacity: 0,
      duration: this.duration,
      ease: 'sine.inOut',
    });
    tl.to(
      this.frames[from],
      {
        opacity: 0,
        duration: this.duration,
        ease: 'sine.inOut',
      },
      `-=${this.overlap}`
    );
    tl.to(
      this.frames[to],
      {
        opacity: 1,
        duration: this.duration,
        ease: 'sine.inOut',
      },
      `+=${this.gap}`
    );
    tl.to(
      this.people[to],
      {
        opacity: 1,
        duration: this.duration,
        ease: 'sine.inOut',
      },
      `-=${this.overlap}`
    );
  }
}

class ScheduleSlider {
  constructor(el) {
    this.roots = document.querySelectorAll('.' + el);
    if (!this.roots.length || typeof Swiper === 'undefined') return;

    this.minSlides = 4;
    this.reduceMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;
    this.canHover = window.matchMedia('(hover: hover)').matches;
    this.spQuery = window.matchMedia('(max-width: 767px)');

    this.items = Array.from(this.roots)
      .map((root) => {
        const viewport = root.querySelector('.c-schedule__viewport');
        const slides = Array.from(root.querySelectorAll('.swiper-slide'));
        return {
          root,
          viewport,
          slides,
          prev: root.querySelector('.js-schedule-prev'),
          next: root.querySelector('.js-schedule-next'),
          count: slides.length,
          swiper: null,
        };
      })
      .filter((item) => item.viewport && item.count >= this.minSlides);

    this.resizeQueued = false;
    this.spQuery.addEventListener('change', () => this.update());
    window.addEventListener('resize', () => {
      if (this.resizeQueued) return;
      this.resizeQueued = true;
      window.requestAnimationFrame(() => {
        this.resizeQueued = false;
        this.updateSpace();
      });
    });
    this.update();
  }

  remSize() {
    const rem = parseFloat(
      getComputedStyle(document.documentElement).fontSize
    );
    return Number.isNaN(rem) ? 10 : rem;
  }

  spaceBetween() {
    return this.remSize() * 3;
  }

  // .c-schedule の左パディング（PC 4rem / SP 2rem）と同じ値。
  // 先頭だけ Swiper の offset にし、右余白は最後のスライド幅に含める
  edgeOffset() {
    return this.spQuery.matches ? this.remSize() * 2 : this.remSize() * 4;
  }

  update() {
    this.items.forEach((item) => {
      if (item.swiper) {
        item.swiper.destroy(true, true);
        item.swiper = null;
      }
      item.swiper = new Swiper(item.viewport, this.options(item));
      this.queueAlign(item.swiper);
    });
  }

  updateSpace() {
    const space = this.spaceBetween();
    const offset = this.edgeOffset();
    this.items.forEach((item) => {
      if (!item.swiper) return;
      item.swiper.params.spaceBetween = space;
      item.swiper.params.slidesOffsetBefore = offset;
      item.swiper.update();
      this.queueAlign(item.swiper);
    });
  }

  queueAlign(swiper) {
    this.alignEndSnap(swiper);
    window.requestAnimationFrame(() => this.alignEndSnap(swiper));
  }

  // 末尾の「少しだけ動く」スナップを捨て、最後のスライド位置で止める
  alignEndSnap(swiper) {
    const grid = swiper.snapGrid;
    if (!grid || grid.length < 2) return;
    const minStep = this.remSize() * 13 + this.spaceBetween();
    while (
      grid.length >= 2 &&
      grid[grid.length - 1] - grid[grid.length - 2] < minStep
    ) {
      grid.splice(grid.length - 2, 1);
    }
    swiper.snapGrid = grid;
    if (typeof swiper.checkOverflow === 'function') {
      swiper.checkOverflow();
    }
  }

  options(item) {
    const offset = this.edgeOffset();
    return {
      slidesPerView: 'auto',
      spaceBetween: this.spaceBetween(),
      slidesOffsetBefore: offset,
      speed: this.reduceMotion ? 0 : 600,
      watchOverflow: true,
      threshold: 8,
      preventClicks: true,
      preventClicksPropagation: true,
      grabCursor: this.canHover,
      navigation: {
        prevEl: item.prev,
        nextEl: item.next,
      },
      a11y: {
        enabled: true,
        slideRole: null,
        prevSlideMessage: '前のスケジュールへ',
        nextSlideMessage: '次のスケジュールへ',
      },
      on: {
        afterInit: (swiper) => this.queueAlign(swiper),
        update: (swiper) => this.queueAlign(swiper),
        resize: (swiper) => this.queueAlign(swiper),
      },
    };
  }
}

// -------------------------------------------------
// スクロール禁止 + スクロールバー幅のずれ補正
// -------------------------------------------------
let scrollTop = 0;
let lockCount = 0;

function getScrollbarWidth() {
  return window.innerWidth - document.documentElement.clientWidth;
}

/**
 * モーダル／ドロワー表示時に呼ぶ（即座にロック＋ padding-right）
 * 多重オープンに備え参照カウントする
 */
function lockBodyScroll() {
  lockCount += 1;
  if (lockCount > 1) return;

  const html = document.documentElement;
  const body = document.body;
  const scrollbarWidth = getScrollbarWidth();

  scrollTop = window.scrollY;
  html.style.top = `${scrollTop * -1}px`;
  html.classList.add('is-hidden');

  // body に加え、fixed 要素は CSS 変数 --scrollbar-compensation を参照して補正する
  html.style.setProperty('--scrollbar-compensation', `${scrollbarWidth}px`);
  if (scrollbarWidth > 0) {
    body.style.paddingRight = `${scrollbarWidth}px`;
  }
}

function applyUnlockStyles() {
  const html = document.documentElement;
  const body = document.body;
  const restoreY = scrollTop;

  html.style.top = '';
  html.classList.remove('is-hidden');
  html.style.setProperty('--scrollbar-compensation', '0px');
  body.style.paddingRight = '';

  // CSS の scroll-behavior: smooth が scrollTo に効かないよう一時的に auto へ
  const prevHtmlBehavior = html.style.scrollBehavior;
  const prevBodyBehavior = body.style.scrollBehavior;
  html.style.scrollBehavior = 'auto';
  body.style.scrollBehavior = 'auto';

  window.scrollTo(0, restoreY);

  html.style.scrollBehavior = prevHtmlBehavior;
  body.style.scrollBehavior = prevBodyBehavior;
}

/**
 * 閉じアニメーション終了後などに呼ぶ
 * ロック時に記憶したスクロール位置へ戻す（scroll-behavior: smooth は一時無効化）
 */
function unlockBodyScroll() {
  if (lockCount === 0) return;
  lockCount -= 1;
  if (lockCount > 0) return;

  applyUnlockStyles();
}

/**
 * 参照カウントを無視して必ず解除する（transitionend 欠落・連打開閉向け）
 */
function forceUnlockBodyScroll() {
  if (lockCount === 0 && !document.documentElement.classList.contains('is-hidden')) {
    return;
  }
  lockCount = 0;
  applyUnlockStyles();
}

/** トグル（後方互換） */
function scrollBan() {
  if (document.documentElement.classList.contains('is-hidden')) {
    forceUnlockBodyScroll();
  } else {
    lockBodyScroll();
  }
}

window.getScrollbarWidth = getScrollbarWidth;
window.lockBodyScroll = lockBodyScroll;
window.unlockBodyScroll = unlockBodyScroll;
window.forceUnlockBodyScroll = forceUnlockBodyScroll;
window.scrollBan = scrollBan;

class ZipSearch {
  constructor(el) {
    this.el = el;
    if (document.querySelectorAll("." + this.el).length > 0) {
      this.event();
    }
  }

  event() {
    const buttons = document.querySelectorAll("." + this.el);

    buttons.forEach((btn) => {
      btn.addEventListener("click", async (e) => {
        e.preventDefault();

        const root = btn.closest("form") || btn.closest(".p-entry") || document;
        const zipName = btn.getAttribute("data-zip-name") || "your-zip";
        const addressName = btn.getAttribute("data-address-name") || "your-address";
        const zipInput = root.querySelector(`[name="${zipName}"]`);
        const addressInput = root.querySelector(`[name="${addressName}"]`);

        if (!zipInput || !addressInput) {
          return;
        }

        const zipcode = String(zipInput.value || "").replace(/[^0-9]/g, "");
        if (zipcode.length !== 7) {
          window.alert("郵便番号はハイフンなしの7桁で入力してください。");
          return;
        }

        btn.disabled = true;

        try {
          const res = await fetch(
            `https://zipcloud.ibsnet.co.jp/api/search?zipcode=${zipcode}`
          );
          const data = await res.json();

          if (!data || data.status !== 200 || !data.results || !data.results[0]) {
            window.alert("住所が見つかりませんでした。郵便番号をご確認ください。");
            return;
          }

          const result = data.results[0];
          addressInput.value = `${result.address1 || ""}${result.address2 || ""}${result.address3 || ""}`;
          addressInput.dispatchEvent(new Event("change", { bubbles: true }));
        } catch (err) {
          window.alert("住所の取得に失敗しました。しばらくしてから再度お試しください。");
        } finally {
          btn.disabled = false;
        }
      });
    });
  }
}


(() => {
  let imgParallax = new ImgParallax('js-parallax');
  let inviewEvent = new InviewEvent('js-inview');
  let formConvert = new FormConvert('js-convert');
  let header = new Header('js-header');
  let mvSlider = new MvSlider('js-mv-slider');
  let interviewSlider = new InterviewSlider('js-interview-slider');
  let zipSearch = new ZipSearch('js-zip-search');
  let formDropzone = new FormDropzone('c-form__dropzone');
  let formPrivacyScroll = new FormPrivacyScroll('c-form-privacy__box');
  let careerSlider = new CareerSlider('js-career-slider');
  let jobSlider = new JobSlider('js-job-slider');
  let scheduleSlider = new ScheduleSlider('js-schedule');
  let interviewListSlider = new InterviewListSlider('js-interview-list');
  let galleryModal = new GalleryModal('js-gallery');
  let breadcrumbOverflow = new BreadcrumbOverflow('c-breadcrumb');
  let dataCharts = new DataCharts('p-data');
  let internshipApplyScroll = new InternshipApplyScroll();
})();

//DOMContentLoaded
$(() => {
});

//images resources loaded
$(window).on('load', () => {

  $(window).trigger('loading');
});

//after loading animation
$(window).on('loading', () => {
});
